import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Algemeen stack layout
 */
export default function AlgemeenLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    />
  );
}

